"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePasswordForm = ChangePasswordForm;
const react_1 = __importStar(require("react"));
const core_1 = require("../core");
require("./styles.css");
const DEFAULT_LABELS = {
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm new password",
    show: "Show",
    hide: "Hide",
    cancel: "Cancel",
    update: "Update password",
    updating: "Updating…",
    criteriaHeader: "New password must include:",
    criteria: {
        length: "8–25 characters",
        uppercase: "1 uppercase letter",
        lowercase: "1 lowercase letter",
        number: "1 number",
        special: "1 special character",
        noSpaces: "No spaces",
    },
    errors: {
        oldPasswordError: "Enter your current password.",
        oldPasswordCriteriaError: "Current password must be 8–25 characters.",
        newPasswordError: "Enter a new password.",
        passwordCriteriaError: "New password doesn't meet the criteria.",
        confirmPasswordError: "Confirm your new password.",
        confirmPasswordMatchError: "Passwords don't match.",
        "wrong-old-password": "Current password is incorrect.",
        "invalid-new-password": "New password doesn't meet the policy.",
        "rate-limited": "Too many attempts. Please try again in a few minutes.",
        "auth-rejected": "Session expired. Please sign in again.",
        "network-error": "Network error. Check your connection and try again.",
        "server-error": "Something went wrong on our side. Please retry.",
        unknown: "Couldn't change password. Please try again.",
    },
};
function defaultErrorMessage(err, labels) {
    var _a;
    // CognitoChangePasswordError from the native adapter carries `.kind`;
    // the web (Amplify) path throws raw Amplify errors. Either way, we
    // only show FE-owned copy — never raw AWS messages.
    if (err &&
        typeof err === "object" &&
        "kind" in err &&
        typeof err.kind === "string") {
        const kind = err.kind;
        return (_a = labels.errors[kind]) !== null && _a !== void 0 ? _a : labels.errors.unknown;
    }
    // Amplify's updatePassword throws ServiceErrors whose `name` matches
    // Cognito's error type (e.g. "NotAuthorizedException"). Reuse the same
    // mapping the native adapter does.
    if (err &&
        typeof err === "object" &&
        "name" in err &&
        typeof err.name === "string") {
        switch (err.name) {
            case "NotAuthorizedException":
                return labels.errors["wrong-old-password"];
            case "InvalidPasswordException":
            case "InvalidParameterException":
                return labels.errors["invalid-new-password"];
            case "LimitExceededException":
            case "TooManyRequestsException":
                return labels.errors["rate-limited"];
        }
    }
    return labels.errors.unknown;
}
function ChangePasswordForm({ onSuccess, onCancel, labels: labelOverrides, colorScheme, }) {
    const labels = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, DEFAULT_LABELS), labelOverrides)), [labelOverrides]);
    const { sessionManager } = (0, core_1.useAuth)();
    const { changePassword, changing } = (0, core_1.useChangePassword)(sessionManager);
    const [oldPassword, setOldPassword] = (0, react_1.useState)("");
    const [newPassword, setNewPassword] = (0, react_1.useState)("");
    const [confirmPassword, setConfirmPassword] = (0, react_1.useState)("");
    const [showOld, setShowOld] = (0, react_1.useState)(false);
    const [showNew, setShowNew] = (0, react_1.useState)(false);
    const [showConfirm, setShowConfirm] = (0, react_1.useState)(false);
    const [touched, setTouched] = (0, react_1.useState)(core_1.INITIAL_TOUCHED);
    const [errors, setErrors] = (0, react_1.useState)(core_1.INITIAL_ERRORS);
    const [submitError, setSubmitError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        setErrors((0, core_1.validateChangePasswordForm)(oldPassword, newPassword, confirmPassword, touched));
    }, [oldPassword, newPassword, confirmPassword, touched]);
    const criteria = (0, react_1.useMemo)(() => (0, core_1.checkPasswordCriteria)(newPassword), [newPassword]);
    const disabled = changing || (0, core_1.isSubmitDisabled)(oldPassword, newPassword, confirmPassword);
    const handleSubmit = (e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        setSubmitError(null);
        try {
            yield changePassword(oldPassword, newPassword);
            onSuccess();
        }
        catch (err) {
            setSubmitError(defaultErrorMessage(err, labels));
        }
    });
    return (react_1.default.createElement("form", { className: "hhn-change-password", "data-hhn-auth-theme": colorScheme, onSubmit: handleSubmit, noValidate: true },
        react_1.default.createElement(PasswordField, { label: labels.currentPassword, value: oldPassword, show: showOld, toggleShow: () => setShowOld(s => !s), showLabel: labels.show, hideLabel: labels.hide, onChange: setOldPassword, onBlur: () => setTouched(t => (Object.assign(Object.assign({}, t), { oldPassword: true }))), errorKey: errors.oldPassword, errors: labels.errors }),
        react_1.default.createElement(PasswordField, { label: labels.newPassword, value: newPassword, show: showNew, toggleShow: () => setShowNew(s => !s), showLabel: labels.show, hideLabel: labels.hide, onChange: setNewPassword, onBlur: () => setTouched(t => (Object.assign(Object.assign({}, t), { newPassword: true }))), errorKey: errors.newPassword, errors: labels.errors }),
        react_1.default.createElement(PasswordCriteriaChecklist, { criteria: criteria, labels: labels.criteria, header: labels.criteriaHeader }),
        react_1.default.createElement(PasswordField, { label: labels.confirmPassword, value: confirmPassword, show: showConfirm, toggleShow: () => setShowConfirm(s => !s), showLabel: labels.show, hideLabel: labels.hide, onChange: setConfirmPassword, onBlur: () => setTouched(t => (Object.assign(Object.assign({}, t), { confirmPassword: true }))), errorKey: errors.confirmPassword, errors: labels.errors }),
        submitError ? (react_1.default.createElement("div", { role: "alert", className: "hhn-cp-form-error" }, submitError)) : null,
        react_1.default.createElement("div", { className: "hhn-cp-actions" },
            onCancel ? (react_1.default.createElement("button", { type: "button", className: "hhn-cp-button hhn-cp-button--secondary", onClick: onCancel, disabled: changing }, labels.cancel)) : null,
            react_1.default.createElement("button", { type: "submit", className: "hhn-cp-button hhn-cp-button--primary", disabled: disabled }, changing ? labels.updating : labels.update))));
}
function PasswordField({ label, value, show, toggleShow, showLabel, hideLabel, onChange, onBlur, errorKey, errors, }) {
    var _a;
    const errorMessage = errorKey
        ? ((_a = errors[errorKey]) !== null && _a !== void 0 ? _a : "")
        : "";
    return (react_1.default.createElement("div", { className: "hhn-cp-field" },
        react_1.default.createElement("label", { className: "hhn-cp-label" }, label),
        react_1.default.createElement("div", { className: "hhn-cp-input-wrap" },
            react_1.default.createElement("input", { type: show ? "text" : "password", className: "hhn-cp-input" + (errorMessage ? " hhn-cp-input--error" : ""), value: value, onChange: e => onChange(e.target.value), onBlur: onBlur, autoComplete: "new-password" }),
            react_1.default.createElement("button", { type: "button", className: "hhn-cp-toggle", onClick: toggleShow, tabIndex: -1 }, show ? hideLabel : showLabel)),
        react_1.default.createElement("div", { className: "hhn-cp-field-error" }, errorMessage)));
}
function PasswordCriteriaChecklist({ criteria, labels, header, }) {
    const items = [
        ["length", criteria.length],
        ["uppercase", criteria.uppercase],
        ["lowercase", criteria.lowercase],
        ["number", criteria.number],
        ["special", criteria.special],
        ["noSpaces", criteria.noSpaces],
    ];
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "hhn-cp-label", style: { marginBottom: 4 } }, header),
        react_1.default.createElement("ul", { className: "hhn-cp-criteria" }, items.map(([key, met]) => (react_1.default.createElement("li", { key: key, className: "hhn-cp-criteria-item" + (met ? " hhn-cp-criteria-item--met" : "") },
            react_1.default.createElement("span", { className: "hhn-cp-criteria-icon", "aria-hidden": true }, met ? "✓" : "○"),
            labels[key]))))));
}
